import { Component, input } from '@angular/core';

@Component({
  selector: 'app-loading-screen',
  imports: [],
  templateUrl: './loading-screen.component.html',
  styleUrl: './loading-screen.component.scss',
  standalone: true,
})
export class LoadingScreenComponent {
  loadingMessage = input<string>('Loading, please wait...');
}
